export enum BookingSubdomainQuoteErrorReason {
    None = 0,
    QuoteNotFound = 1,
    QuoteAlreadyBooked = 2,
    QuoteExpired = 3,
    OrderTotalMismatch = 4,
    BalanceDueMismatch = 5,
    BalanceDueMismatchJobs = 6,
    PaymentDeclined = 7,
    BookQuoteJobsCommandFailed = 8,
    SameAndNextDayNotAllowed = 9,
}

const bookingSubdomainQuoteErrorReasonDescription = {
    None: 'None',
    QuoteNotFound: 'Quote Not Found',
    QuoteAlreadyBooked: 'Quote Already Booked',
    QuoteExpired: 'Quote Expired',
    OrderTotalMismatch: 'Order Total Mismatch',
    BalanceDueMismatch: 'Balance Due Mismatch',
    BalanceDueMismatchJobs: 'Balance Due Mismatch Jobs',
    PaymentDeclined: 'Payment Declined',
    BookQuoteJobsCommandFailed: 'Book Quote Jobs Command Failed',
    SameAndNextDayNotAllowed: 'Same And Next Day Not Allowed',
};

export const BookingSubdomainQuoteErrorReasonDescription = {
    ...bookingSubdomainQuoteErrorReasonDescription,

    get: (value: BookingSubdomainQuoteErrorReason | undefined | null): string | undefined => {
        if (typeof (value) === "string") {
            return bookingSubdomainQuoteErrorReasonDescription[value];
        }
        if (value===null || value===undefined) {
            return undefined;
        }
        return bookingSubdomainQuoteErrorReasonDescription[BookingSubdomainQuoteErrorReason[value]  as keyof typeof bookingSubdomainQuoteErrorReasonDescription];
    },
    all: [
        { value: 0, label: bookingSubdomainQuoteErrorReasonDescription.None },
        { value: 1, label: bookingSubdomainQuoteErrorReasonDescription.QuoteNotFound },
        { value: 2, label: bookingSubdomainQuoteErrorReasonDescription.QuoteAlreadyBooked },
        { value: 3, label: bookingSubdomainQuoteErrorReasonDescription.QuoteExpired },
        { value: 4, label: bookingSubdomainQuoteErrorReasonDescription.OrderTotalMismatch },
        { value: 5, label: bookingSubdomainQuoteErrorReasonDescription.BalanceDueMismatch },
        { value: 6, label: bookingSubdomainQuoteErrorReasonDescription.BalanceDueMismatchJobs },
        { value: 7, label: bookingSubdomainQuoteErrorReasonDescription.PaymentDeclined },
        { value: 8, label: bookingSubdomainQuoteErrorReasonDescription.BookQuoteJobsCommandFailed },
        { value: 9, label: bookingSubdomainQuoteErrorReasonDescription.SameAndNextDayNotAllowed },
    ] as ReadonlyArray<{label: string, value: number}>
};
